import { Link } from 'react-router-dom';

export default function BrandIntro() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <h1 className="text-3xl md:text-4xl font-semibold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
            关于裸肌研究所
          </h1>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            回归本真，唤醒肌肤自愈力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-16">
          <div>
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20skincare%20laboratory%20with%20clean%20white%20surfaces%20and%20natural%20botanical%20elements%2C%20warm%20natural%20lighting%2C%20serene%20professional%20atmosphere%2C%20editorial%20photography&width=700&height=500&seq=about-brand-01&orientation=landscape"
              alt="裸肌研究所"
              className="rounded-lg w-full"
            />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              我们的故事
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              裸肌研究所成立于2023年，由一群热爱科学护肤的皮肤科医生、配方师和内容创作者共同打造。我们目睹了太多人陷入"护肤品成瘾"的困境——梳妆台上堆满瓶瓶罐罐，皮肤却越来越敏感脆弱。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              于是我们决定做一件事：用科学的态度和极简的方法，帮助每个人找到真正适合自己的护肤方案。我们相信，好的皮肤来自于对肌肤的尊重和理解，而非对产品的盲目依赖。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              全裸护肤不是什么都不用，而是回归护肤的本质——清洁、保湿、防晒。在这三步基础之上，根据肌肤的真实需求精准选择产品。少即是多，简即是美。
            </p>
          </div>
        </div>

        <div className="mb-16">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
            我们的使命
          </h2>
          <p className="text-center text-lg text-foreground-700 max-w-2xl mx-auto leading-relaxed mb-10" style={{ fontFamily: "var(--font-heading)" }}>
            成为华语世界最值得信赖的极简护肤知识平台
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { icon: 'ri-flask-line', title: '科学为本', desc: '所有内容基于经过验证的科研成果，拒绝护肤玄学' },
              { icon: 'ri-drop-line', title: '极简主义', desc: '倡导精简护肤，用最少的步骤达到最佳效果' },
              { icon: 'ri-user-heart-line', title: '个体定制', desc: '尊重每个人的肤质差异，提供个性化护肤建议' },
              { icon: 'ri-shield-check-line', title: '透明真诚', desc: '不做夸大宣传，如实呈现护肤的真实效果与局限' },
            ].map((value, i) => (
              <div key={i} className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className={`${value.icon} text-lg`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">{value.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-8 text-center" style={{ fontFamily: "var(--font-heading)" }}>
            核心团队
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20doctor%20portrait%20in%20white%20coat%2C%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=300&height=300&seq=team-01&orientation=squarish', name: '林清悦', role: '联合创始人 / 主笔', desc: '北京大学皮肤科学博士，前皮肤科医生，10年临床经验。擅长将复杂的皮肤科学转化为通俗易懂的日常护肤建议。' },
              { avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20scientist%20portrait%2C%20warm%20expression%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=300&height=300&seq=team-02&orientation=squarish', name: '陈素心', role: '联合创始人 / 内容总监', desc: '化妆品配方师，曾任职于国际知名护肤品牌研发部门。精通成分分析，善于用科学数据说话。' },
              { avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20editor%20portrait%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=300&height=300&seq=team-03&orientation=squarish', name: '王美琳', role: '资深编辑', desc: '美容媒体从业8年，专注护肤科普写作。文风亲切易懂，善于用生活化的语言传递专业护肤知识。' },
            ].map((member, i) => (
              <div key={i} className="bg-background-50 rounded-lg p-6 border border-background-200/70 text-center">
                <img
                  src={member.avatar}
                  alt={member.name}
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-base font-semibold text-foreground-950 mb-1">{member.name}</h3>
                <p className="text-xs text-primary-500 mb-3 whitespace-nowrap">{member.role}</p>
                <p className="text-xs text-foreground-500 leading-relaxed">{member.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}